<div class="pi">
  <div class="bk-field pi__country">
    <label class="bk-field__label" [for]="selectId">Country</label>
    <select
      class="bk-field__input"
      [id]="selectId"
      [disabled]="disabled"
      [ngModel]="country.code"
      (ngModelChange)="onCountry($event)"
    >
      @for (c of countries; track c.code) {
        <option [value]="c.code">{{ c.name }} ({{ c.dialCode }})</option>
      }
    </select>
  </div>

  <div class="bk-field pi__number" [class.is-invalid]="showInvalid">
    <label class="bk-field__label" [for]="inputId">Test number</label>
    <div class="bk-field__control pi__control">
      <span class="pi__dial" aria-hidden="true">{{ country.dialCode }}</span>
      <input
        class="pi__input"
        type="tel"
        inputmode="tel"
        autocomplete="off"
        placeholder="Mobile number"
        [id]="inputId"
        [value]="displayValue"
        [disabled]="disabled"
        [attr.aria-invalid]="showInvalid"
        [attr.aria-describedby]="messageId"
        (input)="onInput($event)"
        (focus)="isFocused = true"
        (blur)="isFocused = false"
      />
      @if (showValidation && isValid === true) {
        <span class="bk-sym pi__ok" aria-hidden="true">check</span>
      }
    </div>
    @if (showInvalid) {
      <p class="bk-field__error" [id]="messageId">
        <span class="bk-sym" aria-hidden="true">error</span>
        This does not look like a {{ country.name }} mobile number. You can still dial with it.
      </p>
    } @else {
      <p class="bk-field__hint" [id]="messageId">The number the application sees as the subscriber.</p>
    }
  </div>
</div>
